var isType = require('./is-type');

var isString = function isString(str) {
  return isType(str, 'String');
};

module.exports = isString;


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@antv_util@1.3.1@@antv/util/lib/type/is-string.js
// module id = 12
// module chunks = 0 1 2